import { FormData } from 'contexts/reward-context'
import { useRewardContext } from 'contexts/useRewardContext'
import { useEffect, useState } from 'react'
import { CiUser } from 'react-icons/ci'
import Select, { StylesConfig } from 'react-select'
import {
  getSearchEmployees,
  SearchEmployees,
} from 'services/get-search-employee'

import { ModalEmployees } from './modal'
import { OptionsEmployee } from './type'

export function ChooseEmployee({ handleClick }: ChooseEmployeeProps) {
  const [employees, setEmployees] = useState<OptionsEmployee[]>([])
  const [inputValue, setInputValue] = useState<string>('')
  const [selectedEmployees, setSelectedEmployees] = useState<any>([])
  const { setSteps } = useRewardContext()
  const [modalEmployees, setModalEmployees] = useState(false)
  const [dataModal, setDataModal] = useState<FormData[]>([])

  useEffect(() => {
    // Carregar o estado inicial do localStorage
    const selectedEmployees = localStorage.getItem('selectedEmployees')
    if (selectedEmployees) {
      setSelectedEmployees(JSON.parse(selectedEmployees))
    }

    // Função para limpar o localStorage antes de recarregar a página
    const handleBeforeUnload = () => {
      localStorage.removeItem('selectedEmployees')
    }

    // Adicionar o event listener para limpar o localStorage
    window.addEventListener('beforeunload', handleBeforeUnload)

    // Limpar o event listener ao desmontar o componente
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])

  // useEffect separado para salvar selectedEmployees no localStorage
  useEffect(() => {
    localStorage.setItem('selectedEmployees', JSON.stringify(selectedEmployees))
  }, [selectedEmployees])

  useEffect(() => {
    const getSearch = async (searchTerm: string) => {
      if (searchTerm?.length >= 5) {
        const employees: any = await getSearchEmployees(searchTerm)

        const result = employees?.data?.map((employee: SearchEmployees) => ({
          value: employee.email,
          label: employee.email,
        }))

        setEmployees(result)
      } else {
        setEmployees([])
      }
    }

    getSearch(inputValue)
  }, [inputValue])

  const customStyles: StylesConfig = {
    option: (provided) => ({
      ...provided,
      color: 'black',
    }),
    multiValue: (provided, state: any) => ({
      ...provided,
      backgroundColor: state.data.color === '#1E40AF' ? '#FDECAF' : '#DBEAFE',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#1E40AF',
    }),
  }

  const components = {
    DropdownIndicator: null,
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!inputValue) return

    if (
      (event.key === 'Enter' || event.key === 'Tab') &&
      employees?.length === 0
    ) {
      setSelectedEmployees((prevSelected: any) => [
        ...prevSelected,
        {
          value: inputValue,
          label: inputValue,
          color: '#1E40AF',
        },
      ])
      setInputValue('')
      event.preventDefault()
    }
  }

  const handleNextStep = () => {
    const arrNewSteps: FormData[] = []

    selectedEmployees?.map((employee: any) => {
      const newSteps: FormData = {
        email: employee.value,
        reward: 0,
        newEmployee: employee.color === '#1E40AF' ? true : false,
      }
      arrNewSteps.push(newSteps)
      return setSteps(arrNewSteps)
    })

    const hasNewEmployee = arrNewSteps.some(
      (employee: FormData) => employee.newEmployee === true,
    )

    if (hasNewEmployee) {
      const onlyNewEmployees = arrNewSteps.filter(
        (employee: FormData) => employee.newEmployee === true,
      )
      setDataModal(onlyNewEmployees)
      setModalEmployees(true)
    } else {
      handleClick(1)
    }
  }

  return (
    <>
      {modalEmployees && (
        <ModalEmployees
          setModalEmployees={setModalEmployees}
          dataModal={dataModal}
          handleClick={handleClick}
        />
      )}
      <section className="w-full h-full flex flex-col">
        <span className="text-xl leading-4 font-semibold">
          1. Adicionar os e-mails dos colaboradores que receberão a premiação
        </span>
        <div className="flex justify-center items-center gap-3 mt-16">
          <CiUser size={'50px'} />
          <span className="text-[#374151] text-xl leading-7 font-medium dark:text-white">
            E-mails:{' '}
          </span>
          <Select
            isMulti
            components={components}
            options={employees}
            className="w-[860px] h-auto"
            inputValue={inputValue}
            onInputChange={(value) => setInputValue(value)}
            noOptionsMessage={() => 'Nenhum colaborador encontrado'}
            placeholder={'Busque por e-mail'}
            menuIsOpen={inputValue?.length >= 5}
            styles={customStyles}
            value={selectedEmployees}
            onChange={(selectedOptions) => {
              setSelectedEmployees(selectedOptions)
            }}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="flex justify-center items-center gap-10 mt-24">
          <button
            type="button"
            className="bg-gray-100 dark:bg-transparent shadow border-[1.5px] rounded-full px-5 py-3 font-medium hover:opacity-95"
            onClick={() => {
              setSelectedEmployees([])
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleNextStep}
            disabled={selectedEmployees.length === 0}
            className={`
              bg-[#4F46E5] text-white rounded-full px-5 py-3 hover:opacity-95
              ${selectedEmployees.length === 0 ? 'cursor-not-allowed bg-[#4F46E5]/80' : ''}
            `}
          >
            Continuar
          </button>
        </div>
      </section>
    </>
  )
}
